import React from 'react';
import { PaginationProps as MaterialPaginationProps, usePagination } from '@material-ui/lab/Pagination';
import clsx from 'clsx';

import { useStyles } from './styles';
import BaseButton from 'features/app/components/BaseButton';
import i18n, { t } from 'locales/i18n';

const mapPaginationType = (type: string) => {
  switch (type) {
    case 'previous':
      return t('pagination.prev');
    case 'next':
      return t('pagination.next');
    default:
      return type;
  }
};

export interface PaginationProps extends MaterialPaginationProps {}

export const Pagination = (props: PaginationProps) => {
  const direction = i18n.dir()

  const classes = useStyles({ direction });
  const { items } = usePagination(props);

  return (
    <nav>
      <ul className={classes.ul}>
        {items.map(({ page, type, selected, ...item }, index) => {
          let children = null;

          if (type === 'start-ellipsis' || type === 'end-ellipsis') {
            children = '…';
          } else if (type === 'page') {
            children = (
              <BaseButton
                type="button"
                variant="text"
                className={clsx(classes.pageItem, {
                  [classes.selected]: selected,
                })}
                {...item}
              >
                {page}
              </BaseButton>
            );
          } else {
            children = (
              <BaseButton {...item} variant="outlined" className={classes.shiftButton}>
                {mapPaginationType(type)}
              </BaseButton>
            );
          }

          return (
            <li
              key={index}
              className={clsx({
                [classes.previous]: type === 'previous',
                [classes.next]: type === 'next',
                [classes.pageItem]: type === 'page',
                [classes.shiftButton]: type === 'previous' || type === 'next',
              })}
            >
              {children}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
